import { useState } from "react";
import { topics } from "@/mocks/homeData";

export default function TopicWall() {
  const [active, setActive] = useState<string>("年度佳片");

  const sizeClass = (size: string) => {
    if (size === "lg") return "text-base md:text-lg px-5 py-3";
    if (size === "md") return "text-sm md:text-base px-4 py-2.5";
    return "text-sm px-3.5 py-2";
  };

  return (
    <section id="topics" className="px-4 md:px-8 py-10 border-t border-background-200/60 bg-background-100/60">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="text-xs tracking-[0.3em] text-secondary-600 font-label mb-2">TOPIC WALL</p>
          <h2 className="font-heading text-xl md:text-3xl font-black text-foreground-950">话题标签墙</h2>
        </div>
        <p className="hidden md:block text-sm text-foreground-500">
          已选标签：<span className="text-primary-600 font-medium">{active}</span> · 共 {topics.length} 个话题
        </p>
      </div>

      <div className="flex flex-wrap gap-3">
        {topics.map((topic) => {
          const isActive = topic.text === active;
          return (
            <button
              type="button"
              key={topic.text}
              onClick={() => setActive(topic.text)}
              className={`rounded-full font-heading font-bold whitespace-nowrap cursor-pointer transition-colors duration-200 border ${sizeClass(
                topic.size,
              )} ${
                isActive
                  ? "bg-primary-600 text-background-50 border-primary-600"
                  : "bg-background-50 text-foreground-800 border-background-200 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              <span className="inline-flex items-center gap-1.5">
                {isActive && <i className="ri-hashtag" />}
                {topic.text}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}